module.exports = __webpack_public_path__ + "media/images/logos/stride-logo-71ac9826776ddafb52890ffb92222275.svg";